module.exports = __webpack_public_path__ + "static/media/boltbox_Logo_New.619a49d6.png";